import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  books: [],
  filter: "All",
  query: "",
};

const booksSlice = createSlice({
  name: "books",
  initialState,
  reducers: {
    getBooks: (state, action) => {
      state.books = action.payload;
    },
    filterBooks: (state, action) => {
      state.filter = action.payload;
    },
    setQuery: (state, action) => {
      state.query = action.payload;
    },
  },
});

export const { getBooks, filterBooks, setQuery } = booksSlice.actions;
export default booksSlice.reducer;
